import { styled, component } from '../../../../utils/style';

interface LogoProps {
	isSvg: boolean;
}

export const Logo = styled<LogoProps>()(component.div, 'Logo') `
	display: flex;
	align-items: center;
	max-height: 43px;
	max-width: 200px;

	& > img {
		max-width: 100%;
		max-height: 43px;
		cursor: pointer;
		${props => props.isSvg ? `height: 43px;` : ''}
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/Logo/styles.ts